document.addEventListener('DOMContentLoaded', () => {
    // Handle filter chip clicks
    const chips = document.querySelectorAll('.filters__chip');
    chips.forEach(chip => {
        chip.addEventListener('click', function() {
            // Remove --active class from all chips
            chips.forEach(c => c.classList.remove('filters__chip--active'));
            // Add --active class to clicked chip
            this.classList.add('filters__chip--active');

            // Run the filter function and update filter options whenever a chip is clicked
            filterCards();
            updateFilterOptions();
        });
    });

	// Handle dropdown change
	var region = document.getElementById('region-select');
	if ( region ){
		region.addEventListener('change', function() {
			// Run the filter function whenever the dropdown selection changes
			filterCards();
			updateFilterOptions();
		});
	}

    // Reset functionality for both desktop and mobile reset buttons
    document.querySelectorAll('.filters__reset').forEach(button => {
        button.addEventListener('click', function() {
            // Remove --active class from all chips
            chips.forEach(c => c.classList.remove('filters__chip--active'));
            // Reset the dropdown
            document.getElementById('region-select').selectedIndex = 0;
            // Reset cards filter and update options
            filterCards(true);
            updateFilterOptions();
        });
    });

    // Initial call to set up the filter options based on current content
    updateFilterOptions();
});

// Filter cards based on selected filters
function filterCards(reset = false) {
    const regionSelectValue = document.getElementById('region-select').value;
    const activeChip = document.querySelector('.filters__chip--active');
    const objectiveFilter = activeChip ? activeChip.getAttribute('value') : '';

    document.querySelectorAll('.card--trust').forEach(card => {
        const cardMeta = card.querySelector('.card-trust-meta');
        const objective = cardMeta.dataset.objective;
        const regionalFocus = cardMeta.dataset.regionalFocus;

        if (reset) {
            card.style.display = '';
        } else {
            if ((regionSelectValue === '' || regionalFocus === regionSelectValue) &&
                (objectiveFilter === '' || objective === objectiveFilter)) {
                card.style.display = '';
            } else {
                card.style.display = 'none';
            }
        }
    });
}

// Function to dynamically update filter options based on available results.
function updateFilterOptions() {
	const regionSelect = document.getElementById('region-select');
	if ( regionSelect ){
		const cards = document.querySelectorAll('.card--trust');
		const chips = document.querySelectorAll('.filters__chip');
		const regionSelectValue = regionSelect.value;
		const activeChip = document.querySelector('.filters__chip--active');
		const objectiveFilter = activeChip ? activeChip.getAttribute('value') : '';

		let availableRegions = new Set();
		let availableObjectives = new Set();

		cards.forEach(card => {
			const cardObjective = card.querySelector('.card-trust-meta').dataset.objective;
			const cardRegion = card.querySelector('.card-trust-meta').dataset.regionalFocus;

			if (!objectiveFilter || cardObjective === objectiveFilter) {
				availableRegions.add(cardRegion);
			}
			if (!regionSelectValue || cardRegion === regionSelectValue) {
				availableObjectives.add(cardObjective);
			}
		});

		Array.from(regionSelect.options).forEach(option => {
			option.disabled = !availableRegions.has(option.value);
		});

		chips.forEach(chip => {
			const chipValue = chip.getAttribute('value');
			chip.disabled = !availableObjectives.has(chipValue);
			if (chip.disabled) {
				chip.classList.add('filters__chip--disabled');
			} else {
				chip.classList.remove('filters__chip--disabled');
			}
		});
	}
}
